export enum MenuPadre {
    MODULO_SOCORROS = 100000,
    MODULO_TRANSPORTE = 200000,
    MODULO_PARAMEDICO = 300000,
    MODULO_SEGURIDAD = 400000,
    MODULO_CATALOGOS = 500000,
    MODULO_REPORTES = 600000,
    MODULO_MONITOREO = 700000,
    MODULO_OPERADOR = 800000,
    MODULO_PLANEACION = 900000,
    MODULO_ABASTECIMIENTO = 110000
}
